import React, { useEffect, useState } from "react";
import "./news-preview.css";
import { convertDateFormat, getNewsTeaser } from "../Transformations/NewsList";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { LinkedInEmbed } from "react-social-media-embed";
import { ElfsightWidget } from "react-elfsight-widget";

export default function NewsPreview() {
	const [newsData, setNewsData] = useState([]);
	const [newsView, setNewsView] = useState([]);
	const navigate = useNavigate();

	const [newsShow, setNewsShow] = useState(3);

	const [modalShow, setModalShow] = useState(false);
	const [isPromo, setIsPromo] = useState(false);

	useEffect(() => {
		const updateNewsShow = () => {
			if (window.innerWidth < 1000) {
				setNewsShow(1);
			} else {
				setNewsShow(isPromo ? 2 : 3);
			}
		};

		updateNewsShow();

		window.addEventListener("resize", updateNewsShow);
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			const data = await getNewsTeaser();
			setNewsData(data);
		};

		fetchData();
	}, []);

	useEffect(() => {
		setNewsView(newsData.slice(0, newsShow));
	}, [newsData]);

	const handlePreviousClick = () => {
		const currentIndex = newsData.findIndex((item) => item === newsView[0]);

		const previousIndex =
			(currentIndex - 1 + newsData.length) % newsData.length;

		setNewsView(newsData.slice(previousIndex, previousIndex + newsShow));
	};

	const handleNextClick = () => {
		const currentIndex = newsData.findIndex((item) => item === newsView[0]);

		const nextIndex = (currentIndex + 1) % newsData.length;

		setNewsView(newsData.slice(nextIndex, nextIndex + newsShow));
	};

	const handleCardClick = (newsId) => {
		navigate(`/unternehmen/news/${newsId}`);
	};

	return (
		<div className="main-fields news-section">
			<div className="field-hd">
				<h2>Aktuelles</h2>
			</div>
			<div
				className={`news-scroll-container d-flex ${
					newsShow == 1 ? "flex-column" : "flex-row"
				} w-100`}
			>
				<div className="news-preview">
					{newsData[0] === newsView[0] ? (
						""
					) : (
						<div className="nav-button" onClick={handlePreviousClick}>
							<button className="nav-imgbtn nav-left"></button>
						</div>
					)}
					<div className="news-container popout-container">
						{newsView.map((news) => (
							<div
								className="news-card popout-content"
								key={news.id}
								onClick={(e) => handleCardClick(news.id)}
							>
								<span className="news-date">
									{convertDateFormat(news.news_date)}
								</span>
								<div className="news-hd">{news.news_hd}</div>
								<div className="news-teaser">{news.news_teaser}</div>

								<Link to={"/unternehmen/news/" + news.id} className="menu_link">
									<div className="news-more news-btn">mehr erfahren ...</div>
								</Link>
							</div>
						))}
					</div>
					{newsData.slice(-1)[0] === newsView.slice(-1)[0] ? (
						""
					) : (
						<div className="nav-button" onClick={handleNextClick}>
							<button className="nav-imgbtn nav-right"></button>
						</div>
					)}
				</div>
				{isPromo && (
					<div
						className={`promo-news  ${
							newsShow == 1 ? "w-100 my-2 text-center" : "w-25 mx-2"
						} `}
					>
						<img
							onClick={() => setModalShow(true)}
							src="https://feingeist-beratung.de/wp-content/uploads/2024/06/2024_Verwaltertag_Ausstellerbutton_Instagram.png"
							alt="promo"
							width="auto"
							height="275px"
						/>
						<Modal
							show={modalShow}
							onHide={() => setModalShow(false)}
							size="lg"
							aria-labelledby="contained-modal-title-vcenter"
							centered
						>
							<Modal.Body>
								<img
									src="https://feingeist-beratung.de/wp-content/uploads/2024/06/2024_Verwaltertag_Ausstellerbutton_Instagram.png"
									alt="promo"
									width="100%"
								/>
							</Modal.Body>
						</Modal>
					</div>
				)}
			</div>
		</div>
	);
}
